import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';
import type SessionContextService from 'tio-employee/services/session-context';

export default class AuthenticatedReimaginedProfileRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;
  @service declare sessionContext: SessionContextService;

  async model() {
    const dataSourceInfo = await this.reimaginedData.getDataSourceInfo();
    const employee = this.sessionContext.currentEmployee;
    const person = this.sessionContext.user?.person;

    return {
      dataSourceInfo,
      employee,
      person,
    };
  }
}
